var _classCallCheck = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var EventEmitter = require('events');

var Tracker = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(Tracker, _EventEmitter);

  var _super = _createSuper(Tracker);

  function Tracker(client, announceUrl) {
    var _this;

    _classCallCheck(this, Tracker);

    _this = _super.call(this);
    _this.client = client;
    _this.announceUrl = announceUrl;
    _this.interval = null;
    _this.destroyed = false;
    return _this;
  }

  _createClass(Tracker, [{
    key: "setInterval",
    value: function (_setInterval) {
      function setInterval(_x) {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function (intervalMs) {
      var _this2 = this;

      if (intervalMs == null) intervalMs = this.DEFAULT_ANNOUNCE_INTERVAL;
      clearInterval(this.interval);

      if (intervalMs) {
        this.interval = setInterval(function () {
          _this2.announce(_this2.client._defaultAnnounceOpts());
        }, intervalMs);
        if (this.interval.unref) this.interval.unref();
      }
    })
  }]);

  return Tracker;
}(EventEmitter);

module.exports = Tracker;